$(function () {

    var logoCarouselWrap = $('.site_logo_carousel__main_wrap');

    if (logoCarouselWrap.length < 1) {
        return;
    }

    /** Carousel controls */
    var prev = '<button class="site_logo_carousel__control site_logo_carousel__control--prev button button--grey"><div class="svg_wrap"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" /></svg></div></button>';
    var next = '<button class="site_logo_carousel__control site_logo_carousel__control--next button button--grey"><div class="svg_wrap"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" /></svg></div></button>';

    /** Append controls */
    logoCarouselWrap.append(prev);
    logoCarouselWrap.append(next);

    /** Add/remove JS */
    $('.site_logo_carousel__slide_wrap').removeClass('site_logo_carousel__slide_wrap--no-js');
    $('.site_logo_carousel__slide').removeClass('site_logo_carousel__slide--no-js');

    var logoCarousel = tns({

        container: '.site_logo_carousel__slide_wrap',
        items: 1,
        gutter: 25,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 7000,
        speed: 1000,
        loop: true,
        nav: false,
        navPosition: 'bottom',
        mouseDrag: false,
        arrowKeys: false,
        touch: true,
        controls: true,
        nextButton: '.site_logo_carousel__control--next',
        prevButton: '.site_logo_carousel__control--prev',
        preventActionWhenRunning: true,
        responsive: {
            480: {
                items: 2,
            },

            640: {
                items: 3,
            },

            960: {
                items: 4,
            },

            1120: {
                items: 5,
            },

            1280: {
                items: 6,
            }

        }

    });

});